import { action, makeObservable, observable } from "mobx";
import { APIBlobResponse } from "../models/NetworkResponse";
import VouchersAPI from "../api/VouchersAPI";
import { PullVoucherRequest, Voucher } from "../models/Vouchers/Voucher";
import { VoucherAPIFilters } from "../models/Vouchers/VoucherFilters";

export class VoucherRequestsStore {
  voucherAPI: VouchersAPI;
  pullVouchersRequests: PullVoucherRequest[];
  limit: number;
  total_count: number;
  total_pages: number;

  constructor() {
    this.voucherAPI = new VouchersAPI();
    this.limit = 0;
    this.total_count = 0;
    this.total_pages = 0;
    this.pullVouchersRequests = [];

    makeObservable(this, {
      limit: observable,
      total_count: observable,
      total_pages: observable,
      pullVouchersRequests: observable,
      getPullVouchersRequests: action,
    });
  }

  getPullVouchersRequests = async () => {
    try {
      const response = await this.voucherAPI.getPullVouchersRequests();
      this.pullVouchersRequests = response.list;
      this.limit = response.limit;
      this.total_pages = response.total_pages;
      this.total_count = response.total_count;
    } catch (error: any) {
      throw error;
    }
  };

  checkPullVoucherRequestStatus = async (id: number, requestId: string) => {
    try {
      const response = await this.voucherAPI.checkPullVoucherRequestStatus(
        id,
        requestId
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  };
}
